import { combineReducers } from "redux";
import { lopReducer } from "./lopReducer";
import { ngayNghiReducer } from "./ngayNghiReducer";

export const danhMucReducerWrapper = combineReducers({

    lop: lopReducer,
    ngayNghi: ngayNghiReducer
})